import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b22ecd10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-row",
  style: {"position":"relative"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex-row",
  style: {"position":"absolute","z-index":"100","left":"0","background":"#ffffff"}
}

import ScBtn from '@/components/common/widget/ScBtn.vue';
import { nextTick, reactive, ref, watch } from 'vue';
import { useElementSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditText',
  props: {
    value: {},
    handler: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const data = reactive({
  edit: false,
  value: props.value,
  width: '',
});

watch(
  () => props.value,
  () => {
    data.value = props.value;
  },
  { immediate: true }
);
const content = ref<HTMLElement>();
const input = ref<HTMLInputElement>();
const { width } = useElementSize(content);

function edit() {
  data.edit = true;
  data.value = props.value;
  data.width = Math.max(width.value, 96) + 'px';
  nextTick(() => input.value?.focus());
}

function close() {
  data.edit = false;
  data.value = props.value;
}

async function submit() {
  if (props.handler) {
    if (await props.handler(data.value)) {
      data.edit = false;
    }
  }
}

function ellipsis(text: string | undefined, max: number) {
  if (!text) {
    return '';
  }
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + '...';
  }
}

function showLong(text: string | undefined, max: number) {
  if (!text) {
    return '';
  }
  if (text.length > max) {
    return text;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex-row",
      style: _normalizeStyle({visibility: data.edit ? 'hidden' : 'visible'})
    }, [
      _createVNode(_component_a_tooltip, {
        title: showLong(_ctx.value, 30),
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "edit-text-box-content",
            ref_key: "content",
            ref: content
          }, _toDisplayString(ellipsis(_ctx.value, 30)), 513)
        ]),
        _: 1
      }, 8, ["title"]),
      (_ctx.handler)
        ? (_openBlock(), _createBlock(ScBtn, {
            key: 0,
            type: "link",
            size: "small",
            "icon-style": "color: #363636",
            icon: "EditOutlined",
            handler: edit
          }))
        : _createCommentVNode("", true)
    ], 4),
    (data.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            class: "edit-text-box-input",
            ref_key: "input",
            ref: input,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value) = $event)),
            style: _normalizeStyle({ width: data.width })
          }, null, 4), [
            [_vModelText, data.value]
          ]),
          _createVNode(ScBtn, {
            type: "link",
            size: "small",
            icon: "CheckOutlined",
            handler: submit
          }),
          _createVNode(ScBtn, {
            type: "link",
            size: "small",
            icon: "CloseOutlined",
            "icon-style": "color: red;",
            handler: close
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})